// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignForm {
  flex: 3;
  max-width: 990px;
}

.CampaignForm .Header1 {
  margin: 2.14rem 0 0.71rem;
}

.CampaignForm .Card {
  margin-bottom: 1rem;
}

.CampaignForm__actions {
  margin-top: 2.14rem;
}

.CampaignForm__actions a {
  margin-left: 1rem;
}

.CampaignForm__actions a:hover {
  text-decoration: none;
}

.CampaignForm__cardWrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
}

.CampaignForm__cardWrapper--twoColumns > div:nth-child(1) {
  flex: 2;
}

.CampaignForm__cardWrapper--twoColumns > div:nth-child(2) {
  flex: 10;
}

.CampaignForm__cardWrapper--threeColumns > div:nth-child(1) {
  flex: 2;
}

.CampaignForm__cardWrapper--threeColumns > div:nth-child(2) {
  flex: 6;
}

.CampaignForm__cardWrapper--threeColumns > div:nth-child(3) {
  flex: 4;
}

.CampaignForm__cardWrapperTitle {
  margin-top: 1.88rem;
  margin-right: 1.43rem;
}

.CampaignForm__cardWrapperTitle .Header5 {
  display: flex;
  align-items: center;
}


.CampaignForm__cardWrapperTitle .Tooltip {
  margin-left: 0.5rem;
  color: #777;
  opacity: 0.5;
  width: 1.714rem;
}

.CampaignForm__cardWrapperInput .Input:not(:first-child) {
  margin-top: 1rem;
}

.CampaignForm__cardWrapper .BidStrategy .Radio:first-child {
  margin-top: 0;
}

.CampaignForm .CollapsibleLink {
  margin-top: 0.85rem;
}

.CampaignForm .ThreeDecimals__warning {
  margin-bottom: 1.70rem;
}

.CampaignForm .CollapsibleLink .CampaignForm__cpc-mobile,
.CampaignForm .CollapsibleLink .CampaignForm__cps-mobile
{
  margin-top: 0;
}

.CampaignForm .Banner--legacy {
  margin-bottom: 1rem;
}

.CampaignForm__cardWrapperInput .MessageCard {
  margin-top: 1rem;
}

.menu-buttons{
  margin-left:auto;
}

.sticky-wrapper{
  display:flex;
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./js/components/UnifiedCampaignForm/CampaignForm.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".CampaignForm {\n  flex: 3;\n  max-width: 990px;\n}\n\n.CampaignForm .Header1 {\n  margin: 2.14rem 0 0.71rem;\n}\n\n.CampaignForm .Card {\n  margin-bottom: 1rem;\n}\n\n.CampaignForm__actions {\n  margin-top: 2.14rem;\n}\n\n.CampaignForm__actions a {\n  margin-left: 1rem;\n}\n\n.CampaignForm__actions a:hover {\n  text-decoration: none;\n}\n\n.CampaignForm__cardWrapper {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n}\n\n.CampaignForm__cardWrapper--twoColumns > div:nth-child(1) {\n  flex: 2;\n}\n\n.CampaignForm__cardWrapper--twoColumns > div:nth-child(2) {\n  flex: 10;\n}\n\n.CampaignForm__cardWrapper--threeColumns > div:nth-child(1) {\n  flex: 2;\n}\n\n.CampaignForm__cardWrapper--threeColumns > div:nth-child(2) {\n  flex: 6;\n}\n\n.CampaignForm__cardWrapper--threeColumns > div:nth-child(3) {\n  flex: 4;\n}\n\n.CampaignForm__cardWrapperTitle {\n  margin-top: 1.88rem;\n  margin-right: 1.43rem;\n}\n\n.CampaignForm__cardWrapperTitle .Header5 {\n  display: flex;\n  align-items: center;\n}\n\n\n.CampaignForm__cardWrapperTitle .Tooltip {\n  margin-left: 0.5rem;\n  color: #777;\n  opacity: 0.5;\n  width: 1.714rem;\n}\n\n.CampaignForm__cardWrapperInput .Input:not(:first-child) {\n  margin-top: 1rem;\n}\n\n.CampaignForm__cardWrapper .BidStrategy .Radio:first-child {\n  margin-top: 0;\n}\n\n.CampaignForm .CollapsibleLink {\n  margin-top: 0.85rem;\n}\n\n.CampaignForm .ThreeDecimals__warning {\n  margin-bottom: 1.70rem;\n}\n\n.CampaignForm .CollapsibleLink .CampaignForm__cpc-mobile,\n.CampaignForm .CollapsibleLink .CampaignForm__cps-mobile\n{\n  margin-top: 0;\n}\n\n.CampaignForm .Banner--legacy {\n  margin-bottom: 1rem;\n}\n\n.CampaignForm__cardWrapperInput .MessageCard {\n  margin-top: 1rem;\n}\n\n.menu-buttons{\n  margin-left:auto;\n}\n\n.sticky-wrapper{\n  display:flex;\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
